import { useSelector } from 'react-redux';

const useAjaibConfig = () => {
  const config = useSelector((state) => state.config?.configData ?? {});
  const isLoading = useSelector((state) => state.config?.configLoading);

  return { config, isLoading };
};

export default useAjaibConfig;
